<div class="modal-body">
  <button *ngFor="let action of data.actions" (click)="onClickAction(action)"
    type="button" class="btn {{action.class || 'btn-outline btn-default-outline text-uppercase'}}"
    [matTooltip]="action.tooltip" [matTooltipPosition]="action.tooltipPosition || 'above'" [matTooltipClass]="action.tooltipClass">
    <i *ngIf="action.icon" class="{{action.icon}}"></i> {{action.text}}
  </button>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> Cancel
  </button>
</div>
